import { PAYMENT_BEHAVIOR } from "@/helpers/order/payment/behavior";
import { makePaymentResult } from "../paymentResult";

/**
 * Cash / direct-charge processor.
 *
 * There is no device round-trip: the cashier enters a tendered amount and the
 * sale is built directly. ALLOW_CHANGE (cash with change) and DIRECT_CHARGE
 * (manual card, no integration) both flow through here and store the legacy
 * "no data" sentinel as their processor_response.
 */
export const cashProcessor = {
  behaviors: [PAYMENT_BEHAVIOR.ALLOW_CHANGE, PAYMENT_BEHAVIOR.DIRECT_CHARGE],

  normalize() {
    return makePaymentResult({
      approved: true,
      processorResponse: "no data",
      cardLastFour: null,
    });
  },
};
